import { useEffect, useState } from "react";
import { _AccountINFORPO, _DocumentFactory, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../../../../../modules/theme/Component/BasicTable"
import usePaginator from "../../../../../../../modules/theme/Component/usePaginator";
import useModal, { MODAL_md, MODAL_SM, MODAL_XL } from "../../../../../../../modules/theme/Component/hooks/useModal";
import { ListMenu } from "../../../../../../../modules/theme/Component/ListMenu";
import { Modal } from "../../../../../../../modules/theme/Component/Modal";
import { InputDate } from "../../../../../../../modules/theme/Input/InputDate";
import { InputMoney } from "../../../../../../../modules/theme/Input/InputMoney";
import { ModalConfirm } from "../../../../../../../modules/theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { ErrorList } from "../../../../../../../modules/theme/Component/ErrorList";
import { DocumentViewer } from "../../../../../../../modules/theme/Component/DocumentViewer";

interface Props {
    _idAccount: number
    Credit: any;
}
export const HistoryCreditInfo = ({ Credit, _idAccount }: Props) => {
    const { instance, bean, setBean, lista, setLista, handleChange } = useDataBean(_AccountINFORPO);
    const doc = useDataBean(_DocumentFactory)

    const paginador = usePaginator();
    const modalEdit = useModal("Editar", MODAL_md);
    const modalDelete = useModal("Eliminar", MODAL_SM);
    const modalDoc = useModal("Documento Contable", MODAL_XL);

    const [msgList, setMsgList] = useState<any>([]);

    useEffect(() => {
        if (_idAccount && Credit.IDCreditAccount) {
            getHistory()
        }
    }, [paginador.page, Credit]);

    const getHistory = () => {
        const props = {
            IDAccount: _idAccount,
            IDCreditAccount: Credit.IDCreditAccount
        }
        instance.getMovimientosRender(paginador.page, 15, props).then(
            (resp) => {

                setLista(resp.List)
                paginador.setPages(resp.NumberOfPages);
            }
        ).catch(
            err => {
                console.log(err)
            }
        )
    }

    const update = () => {
        instance.updateCreditHistory(bean).then(
            (resp: any) => {
                getHistory();
                modalEdit.close();
            }
        )
    }
    const deleteItem = () => {
        instance.deleteCreditHistory(bean.IDCreditHistory).then(
            (resp: any) => {
                getHistory();
                modalDelete.close();
            }
        )

    }

    const headHistory = [
        { title: 'ID', property: 'IDCreditHistory', visible: false, mask: MASK_NUMBER },
        { title: 'Periodo', property: 'Periodo', visible: true, mask: MASK_NUMBER },
        { title: 'Movimiento', property: 'TypeMovementName', visible: true },
        { title: 'Documento', property: 'DocumentPayment', visible: true },
        { title: 'CXC Capital Corriente', property: 'CapitalCorriente', visible: true, mask: MASK_MONEY },
        { title: 'CXC Interes Corriente', property: 'InteresCorriente', visible: true, mask: MASK_MONEY },
        // { title: 'Interes Vencido', property: 'SaldoInteresMora', visible: true, mask: MASK_MONEY },
        // { title: 'Capital Vencido', property: 'SaldoMoraCapital', visible: true, mask: MASK_MONEY },
        { title: 'Valor Cuota', property: 'ValorTotal', visible: true, mask: MASK_MONEY },
        { title: 'Pago Recibido', property: 'CurrentPayment', visible: true, mask: MASK_MONEY },
        { title: '(-) Pago a Interes Vencido', property: 'DefeteadInterestPayment', visible: true, mask: MASK_MONEY },
        { title: '(-) Pago a Interes Corriente', property: 'CurrentInterestPayment', visible: true, mask: MASK_MONEY },
        { title: '(-) Pago a Capital Vencido', property: 'DefeatedCapitalPayment', visible: true, mask: MASK_MONEY },
        { title: '(-) Pago a Capital Corriente', property: 'CurrentCapitalPayment', visible: true, mask: MASK_MONEY },
        { title: '(+) Capital Vencido', property: 'DefeatedCapital', visible: true, mask: MASK_MONEY },
        { title: '(+) Interes Vencido', property: 'DefeatedInterest', visible: true, mask: MASK_MONEY },
        { title: '(=) Saldo Capital Vencido', property: 'DefeatedCapitalLeft', visible: true, mask: MASK_MONEY },
        { title: '(=) Saldo Interes Vencido', property: 'DefeatedInterestLeft', visible: true, mask: MASK_MONEY },
        { title: '(=) Total Vencido', property: 'TotalVencido', visible: true, mask: MASK_MONEY },
        { title: '(=) Saldo Capital Corriente', property: 'CurrentCapitalLeft', visible: true, mask: MASK_MONEY },
        { title: 'Saldo Mayor Valor', property: 'HighestValuePaid', visible: true, mask: MASK_MONEY },

        // { title: 'Capital Vencido antes de aplicar pago', property: 'InitialDefeatedCapital', visible: false, mask: MASK_MONEY },
        // { title: 'Interes Vencido antes de aplicar pago', property: 'InitialDefeatedInterest', visible: false, mask: MASK_MONEY },
        // { title: 'Capital Inicial antes de aplicar pago', property: 'InitialCurrentCapital', visible: false, mask: MASK_MONEY },
        // { title: 'Cuotas Pagadas', property: 'CuotasPagadas', visible: false, mask: MASK_NUMBER },
        // { title: 'Dias Vencidos', property: 'DiasCastigo', visible: false },
        { title: 'Fecha Movimiento', property: 'FechaUltimoPago', visible: true, mask: MASK_DATE },


    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-file-add-line', visible: _single.canEdit(), evento: () => { modalEdit.open() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-6-line', visible: _single.canDelete(), evento: () => { modalDelete.open() } },
            { titulo: 'Ver Documento', icono: 'ri-eye-line', visible: bean.IDDocument, evento: () => { getDocument(bean.IDDocument, bean.DocumentDate) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const getDocument = (idDocument: number, docDate: any) => {
        doc.instance.getAccountantDocumentByLocation(idDocument, docDate).then(
            (resp) => {
                doc.setLista(resp.DocumentURL)
                modalDoc.open()
                setMsgList(resp.MsgList);
            }
        ).catch(err => { toast.error(err) })
    }

    return (
        <>
            <BasicTable
                listButtons={listaBotones()}
                body={lista}
                head={headHistory}
                rowSet={setBean}
                pageTop={paginador.page}
                next={paginador.next}
                back={paginador.back}
                records={paginador}
            />
            <Modal modal={modalEdit.modal} updateModal={modalEdit.setModal} eventModal={update}>
                <div className="row">
                    <div className="col-md-6">
                        <label>Periodo</label>
                        <input className="form-control" type="number" name="Periodo" id="periodo" value={bean.Periodo} onChange={handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Cuotas Pagadas</label>
                        <input className="form-control" type="number" name="CuotasPagadas" id="periodo" value={bean.CuotasPagadas} onChange={handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Dias Castigo</label>
                        <input className="form-control" type="number" name="DiasCastigo" id="periodo" value={bean.DiasCastigo} onChange={handleChange} />
                    </div>
                    <div className="col-md-6">
                        <InputDate label="Fecha Ultimo Pago" name="FechaUltimoPago" value={bean.FechaUltimoPago} setDate={(e) => { setBean({ ...bean, "FechaUltimoPago": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <InputMoney _label="Pago Capital" _value={bean.PagoCapital} onChange={(e) => { setBean({ ...bean, "PagoCapital": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <InputMoney _label="Pago Interes Corriente" _value={bean.PagoInteresCorriente} onChange={(e) => { setBean({ ...bean, "PagoInteresCorriente": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <InputMoney _label="Pago Interes Mora" _value={bean.PagoInteresMora} onChange={(e) => { setBean({ ...bean, "PagoInteresMora": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <InputMoney _label="Saldo Capital" _value={bean.SaldoCapital} onChange={(e) => { setBean({ ...bean, "SaldoCapital": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <InputMoney _label="Saldo Interes Mora" _value={bean.SaldoInteresMora} onChange={(e) => { setBean({ ...bean, "SaldoInteresMora": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <InputMoney _label="Saldo Mora Capital" _value={bean.SaldoMoraCapital} onChange={(e) => { setBean({ ...bean, "SaldoMoraCapital": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <InputMoney _label="Saldo Mora Interes" _value={bean.SaldoMoraInteres} onChange={(e) => { setBean({ ...bean, "SaldoMoraInteres": e }) }} />
                    </div>
                </div>
            </Modal>
            <ModalConfirm modal={modalDelete.modal} updateModal={modalDelete.setModal} eventModal={deleteItem}>
                <p>Seguro de eliminar movimiento</p>
            </ModalConfirm>

            <Modal modal={modalDoc.modal} updateModal={modalDoc.setModal} >
                <div className="row">
                    <div className="col">
                        {msgList.length > 0 &&
                            <ErrorList lista={msgList} />
                        }
                        {msgList.length === 0 && lista.length > 0 &&
                            <DocumentViewer key={doc.lista} list={doc.lista} />
                        }
                    </div>
                </div>
            </Modal>
        </>
    )
}